import React, {useEffect, useState} from "react";
import {FilterMatchMode} from "primereact/api";
import {useNavigate} from "react-router-dom";
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Tag} from "primereact/tag";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {getUnitCatalog} from "./Integration";
import { Image } from 'primereact/image';
import * as XLSX from 'xlsx';


const UnitsList = () => {

    const ROW_HEIGHT = 68;
    const [units, setUnits] = useState(null);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [loading, setLoading] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const navigate = useNavigate();

    const getSeverity = (status) => {
        switch (status) {
            case 'EMPRESARIAL':
                return 'success';
            case 'ADMINISTRATIVA':
                return 'info';
            case 'VENDER':
                return 'warning';
            case 'NUEVA EQUIPAMIENTO':
                return 'primary';
            default:
                return 'danger';
        }
    };

    useEffect(() => {
        getUnitCatalog().then((data) => {
            const normalized = (data || []).map(u => ({
                ...u,
                ID:           String(u.ID ?? ''),
                MARCA:        String(u.MARCA ?? '').trim(),
                MODELO:       String(u.MODELO ?? '').trim(),
                TIPO:         String(u.TIPO ?? '').trim(),
                CLIENTE:      String(u.CLIENTE ?? 'SIN CLIENTE').trim(),
                OPERADOR:     String(u.OPERADOR ?? '').trim(),
                PLACAS:       String(u.PLACAS ?? '').trim(),
                NUMERO_MOTOR: String(u.NUMERO_MOTOR ?? '').trim(),
                NUMERO_SERIE: String(u.NUMERO_SERIE ?? '').trim(),
                ESTATUS:      String(u.ESTATUS ?? '').trim(),
                DESCRIPCION:  String(u.DESCRIPCION ?? '').trim(),
            }));
            setUnits(normalized);
            setLoading(false);
        });
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const exportExcel = () => {
        const datos = (units || []).map(({ FOTO, ...rest }) => rest);
        const hoja = XLSX.utils.json_to_sheet(datos);
        const libro = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(libro, hoja, 'Hoja1');
        XLSX.writeFile(libro, 'catalogo-unidades.xlsx');
    };

    const renderHeader = () => {
        return (
            <div className="table-service-header flex flex-wrap justify-content-between align-items-center gap-3 md:p-3 mx-auto">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Buscar" />
                </IconField>
                <div className="flex gap-2">
                    <Button label="Descargar Excel" icon="pi pi-download" severity="success" onClick={exportExcel} />
                    <Button icon="pi pi-plus" label="Nuevo" onClick={() => navigate(`/mantenimiento/catalogos-unidades/nuevo`)} />
                </div>
            </div>
        );
    };

    const handleNavigate = (id) => {
        navigate(`/mantenimiento/catalogos-unidades/${id}`);
    };

    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.ESTATUS} severity={getSeverity(rowData.ESTATUS)} />;
    };

    const imageBodyTemplate = (rowData) => {
        return <Image src={rowData.FOTO} zoomSrc={rowData.FOTO} alt="Image" width="80" height="60" preview />

    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => handleNavigate(rowData.ID)} />
            </div>
        );
    };

    const header = renderHeader();

    return (
        <div className="card">
            <DataTable
                key='service-datatable'
                value={units}
                showGridlines
                loading={loading}
                dataKey="ID"
                scrollable
                scrollHeight="calc(100vh - 155px)"
                virtualScrollerOptions={{
                    itemSize: ROW_HEIGHT,
                    showLoader: true,
                }}
                filters={filters}
                size='small'
                className='special-service-table'
                globalFilterFields={['ID', 'ESTATUS', 'MARCA', 'MODELO', 'TIPO',
                    'CLIENTE', 'NUMERO_MOTOR', 'NUMERO_SERIE', 'OPERADOR', 'PLACAS', 'PLACAS_FEDERALES']}
                header={header}
                emptyMessage="No se encontraron servicios">
                <Column body={actionBodyTemplate} exportable={false} style={{minWidth: '5rem'}}></Column>
                <Column field="ID" header="ID" sortable style={{minWidth: '5rem'}}/>
                <Column field="FOTO" header="IMAGEN" style={{minWidth: '5rem'}} body={imageBodyTemplate}/>
                <Column field="ESTATUS" header="ESTATUS" sortable style={{minWidth: '12rem'}} body={statusBodyTemplate}/>
                <Column header="KILOMETRAJE" field="KILOMETRAJE" style={{minWidth: '8rem'}}/>
                <Column header="DESCRIPCION" field="DESCRIPCION" style={{minWidth: '8rem'}}/>
                <Column header="MARCA" field="MARCA" style={{minWidth: '8rem'}}/>
                <Column header="MODELO" field="MODELO" style={{minWidth: '8rem'}}/>
                <Column header="PASAJEROS" field="PASAJEROS" style={{minWidth: '5rem'}}/>
                <Column header="RENDIMIENTO" field="RENDIMIENTO" style={{minWidth: '8rem'}}/>
                <Column header="TIPO" field="TIPO" sortable style={{minWidth: '12rem'}}/>
                <Column header="CLIENTE" field='CLIENTE' style={{minWidth: '8rem'}}/>
                <Column header="OPERADOR" field='OPERADOR' style={{minWidth: '12rem'}}/>
                <Column header="PLACAS" field='PLACAS' style={{minWidth: '5rem'}}/>
                <Column header="PLACAS FEDERALES" field='PLACAS_FEDERALES' style={{minWidth: '5rem'}}/>
                <Column header="NUMERO_MOTOR" field='NUMERO_MOTOR' style={{minWidth: '8rem'}}/>
                <Column header="NUMERO_SERIE" field='NUMERO_SERIE' style={{minWidth: '8rem'}}/>
            </DataTable>
        </div>
    );
}
export default UnitsList;